import { render } from "./StDetail.vue?vue&type=template&id=8fc57bdc&scoped=true"
import script from "./_StDetail.js?vue&type=script&lang=js"
export * from "./_StDetail.js?vue&type=script&lang=js"

import "./_StDetail.less?vue&type=style&index=0&id=8fc57bdc&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc57bdc"]])

export default __exports__